import { ExclamationTriangleIcon, ServerIcon } from '@heroicons/react/24/outline';
import { useEnvironment } from '../context/EnvironmentContext';

export default function EnvironmentSelector() {
  const { envName, envColor, envBgColor, envTextColor, isProduction } = useEnvironment();

  return (
    <div
      className="flex items-center gap-2 rounded-lg border px-3 py-2"
      style={{ backgroundColor: envBgColor, borderColor: envColor }}
      title="This deployment is permanently bound to one backend and Firebase project"
    >
      <ServerIcon className="h-4 w-4" style={{ color: envColor }} />
      <span className="text-sm font-medium" style={{ color: envTextColor }}>{envName}</span>
      {isProduction && <ExclamationTriangleIcon className="h-4 w-4" style={{ color: envColor }} />}
    </div>
  );
}
